import { FormStateModel } from 'src/app/form.state.model';
import { ILogin } from 'src/app/interfaces/errorsType';

import { OrgTypesModel } from '../models/org-types.model';
import { PinLoginModel } from '../models/pin-login.model';

export class AuthStateModel {
    username: string;
    access_token: string;
    loginError: ILogin;
    pinToken: string;
    user_pool_id: string;
    pinLogin: PinLoginModel;
    orgTypes: OrgTypesModel[] = [];
    signUpForm = new FormStateModel();
    resetForm = new FormStateModel();
    forgotForm = new FormStateModel();
    forgotPinForm = new FormStateModel();
    pinCodeForm = new FormStateModel();
    feedBackForm = new FormStateModel<{ message: string; image: string }>();
}
